// Ordered newest first. `links` is optional: [{ label, href }]
export const newsData = [
  {
    id: 1,
    title: "Two Papers Accepted at IEEE IROS 2026",
    content:
      "Two papers were accepted to the IEEE/RSJ International Conference on Intelligent Robots and Systems (IROS) 2026: BOWConnect: Parallel Bayesian Optimization over Windows with Learned Local Cost Maps for Sample-Efficient Kinodynamic Motion Planning, and Localization in Spatiotemporal Fields via Environmental PDEs.",
    date: "JUN 2026",
    links: [
      { label: "LinkedIn Post", href: "https://www.linkedin.com/feed/update/urn:li:activity:7472833689278808064/" },
      { label: "BOWConnect Project", href: "https://bow-connect.github.io/" },
      { label: "Localization Project", href: "https://localization-environmental-pdes.github.io/" },
    ],
  },
  {
    id: 2,
    title: "NSF Award: ERI AQUABOT",
    content:
      "The National Science Foundation has awarded ERI: AQUABOT: Advancing Water Quality Monitoring with an Intelligent Bot via Integrated Learning and Decision-Making to Dr. Abdullah Al Redwan Newaz (PI). Amount: $197,022 over two years, August 2026 to August 2028. The project puts the lab's uncertainty-aware sampling and decision-making methods on an intelligent robotic boat for autonomous water quality monitoring.",
    date: "APR 2026",
    links: [
      { label: "LinkedIn Post", href: "https://www.linkedin.com/feed/update/urn:li:activity:7452703944138575872/" },
    ],
  },
  {
    id: 3,
    title: "AiR Lab Research Funding Surpasses $1.3 Million",
    content:
      "With awards from the U.S. Environmental Protection Agency, the National Science Foundation, and the National Institutes of Health (through the Louisiana Biomedical Research Network), the AiR Lab has now secured more than $1.3 million in competitive federal funding with Dr. Newaz as Principal Investigator, complemented by equipment grants supporting the lab's drone, boat, and manipulator fleets.",
    date: "MAR 2026",
    links: [
      { label: "LinkedIn", href: "https://www.linkedin.com/in/abdullah-al-redwan-newaz-5ba849130/" },
    ],
  },
  {
    id: 4,
    title: "NIH/LBRN Award: Multirobot ABA Therapy for Children with ASD",
    content:
      "Next Generation Multirobot Applied Behavior Analysis Therapy for Children with Autism Spectrum Disorder has been funded by the Louisiana Biomedical Research Network (NIH). Abdullah Al Redwan Newaz (PI) with Md Tamjidul Hoque, James Wagner, Ben Samuel, and Elliott Beaton (Co-PIs). Amount: $517,909 over two years, August 2026 to August 2028.",
    date: "FEB 2026",
  },
  {
    id: 5,
    title: "Paper Accepted at IEEE ICRA 2026",
    content:
      "Multi-Robot Trajectory Planning via Constrained Bayesian Optimization and Local Cost Map Learning with STL-Based Conflict Resolution was accepted to the IEEE International Conference on Robotics and Automation (ICRA) 2026.",
    date: "JAN 2026",
    links: [
      { label: "LinkedIn Post", href: "https://www.linkedin.com/feed/update/urn:li:activity:7423386770018451456/" },
      { label: "Project Site", href: "https://stlbot.github.io/" },
    ],
  },
  {
    id: 6,
    title: "IEEE RA-L 2026 Paper",
    content:
      "Energy-Efficient Multi-Robot Coverage Path Planning of Non-Convex Regions of Interests was accepted to IEEE Robotics and Automation Letters, extending the lab's wetland-monitoring work to large, obstacle-filled survey regions.",
    date: "JAN 2026",
    links: [{ label: "Project Site", href: "https://mrc-pp.github.io/" }],
  },
  {
    id: 7,
    title: "New Course: CSCI 4490 Autonomous Robotics",
    content:
      "A new undergraduate course, CSCI 4490 Autonomous Robotics, has been developed and will be offered in Fall 2026, covering robot topology, control, path and motion planning, and learning-based autonomy with hands-on drone and ground-robot labs.",
    date: "NOV 2025",
  },
  {
    id: 8,
    title: "Professional Service: Associate Editor and NSF Panels",
    content:
      "Dr. Newaz serves as Associate Editor of the Intelligent Service Robotics journal, has served three times on NSF Cyber-Physical Systems (CPS) review panels since 2024, and was an invited participant at the NSF Aspiring PI Meeting.",
    date: "SEP 2025",
  },
  {
    id: 9,
    title: "Double Best Paper Finalist at IEEE ICRA 2025",
    content:
      "AiR Lab fieldwork was named a finalist for both the Best Conference Paper Award and the Best Paper Award in Field and Service Robotics at IEEE ICRA 2025. Dr. Newaz also served as a Session Chair at the conference, where Learning-based Adaptive Navigation for Scalar Field Mapping and Feature Tracking was presented.",
    date: "MAY 2025",
  },
  {
    id: 10,
    title: "EPA Award: Multi-UAV Wetland Monitoring",
    content:
      "Intelligent MultiUAV Surveillance System for Spatiotemporal Monitoring and Prediction of Wetland Loss is funded by the U.S. EPA Lake Pontchartrain Basin Restoration Program. Abdullah Al Redwan Newaz (PI) with Md Tamjidul Hoque and Mark Kulp (Co-PIs). Amount: $596,017, March 2025 to February 2028.",
    date: "MAR 2025",
  },
  {
    id: 11,
    title: "Equipment Grants Expand Lab Infrastructure",
    content:
      "Two equipment awards expanded the lab: Computation Hardware for Data Science and AI Research (LBRN/NIH, $30,000, plus $35,000 in departmental funding), and Robotic Manipulators for the Autism-Focused Robotics Initiative ($16,055), which replaces robotic arms and supports undergraduates developing AI-based interaction algorithms.",
    date: "MAR 2025",
  },
  {
    id: 12,
    title: "IEEE RA-L 2025 Paper: BOW",
    content:
      "BOW: Bayesian Optimization over Windows for Motion Planning in Complex Environments was accepted to IEEE Robotics and Automation Letters, introducing a sample-efficient, constraint-aware planner for cluttered environments.",
    date: "FEB 2025",
    links: [{ label: "Project Site", href: "https://bow-web.github.io/" }],
  },
  {
    id: 13,
    title: "IEEE RA-L 2024 Paper",
    content:
      "One paper got accepted to IEEE RA-L 2024, LCD-RIG: Limited Communication Decentralized Robotic Information Gathering Systems.",
    date: "SEP 2024",
    links: [{ label: "Project Site", href: "https://lcd-rig.github.io/" }],
  },
  {
    id: 14,
    title: "TRB 2024 Presentation",
    content:
      "One paper got recommended for presentation at the TRB Annual Meeting, Enhancing Pedestrian Detection in Autonomous Vehicles through Multi-modal Information Fusion.",
    date: "SEP 2024",
  },
  {
    id: 15,
    title: "IEEE ROMAN 2024 Paper",
    content:
      "One paper got accepted to IEEE ROMAN 2024, YoloTag: Vision-based Robust UAV Navigation with Fiducial Markers. Sourav received a travel grant to attend this conference.",
    date: "JUN 2024",
  },
  {
    id: 16,
    title: "Ubiquitous Robots 2024 Papers",
    content:
      "Two papers got accepted to International Conference on Ubiquitous Robots, 2024, Adaptive Dynamic Window Approach for Robot Navigation in Disturbance Vector Fields, and Randomized Multi-Robot Patrolling with Unidirectional Visibility.",
    date: "FEB 2024",
  },
];
